import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FoldersHeader';
import { AppState } from '../../../../../types/store';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'gallectionType'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  gallectionType: getGallectionSectionType(state),
});

export default connect(mapStateToProps);
